(() => {
  const header = document.getElementById("site-header");
  if (!header) return;

  if (header.dataset.autoBorderSwitch !== "true") return;

  const borderDark = header.dataset.borderDark;   // for light backgrounds
  const borderLight = header.dataset.borderLight; // for dark backgrounds

  const fallbackDark =
    getComputedStyle(document.documentElement)
      .getPropertyValue("--color-foreground-accent-header")
      .trim() || "#111";

  function parseColorToRGB(color) {
    const el = document.createElement("div");
    el.style.color = color;
    document.body.appendChild(el);
    const rgb = getComputedStyle(el).color;
    document.body.removeChild(el);
    const m = rgb.match(/\d+/g);
    return m ? [parseInt(m[0], 10), parseInt(m[1], 10), parseInt(m[2], 10)] : [0, 0, 0];
  }

  function luminance([r, g, b]) {
    const a = [r, g, b].map((v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }

  function getHeaderTextColor() {
    // Prefer the theme CSS var, fallback to computed text color
    return (
      getComputedStyle(header).getPropertyValue("--color-text-header").trim() ||
      getComputedStyle(header).color ||
      "#000"
    );
  }

  function applyBorder() {
    const textLum = luminance(parseColorToRGB(getHeaderTextColor()));
    const isLightText = textLum > 0.6;

    header.style.setProperty(
      "--header-border-color",
      isLightText ? (borderLight || "#fff") : (borderDark || fallbackDark)
    );
  }

  applyBorder();
  window.addEventListener("scroll", applyBorder, { passive: true });
  window.addEventListener("resize", applyBorder);
})();
